import { ConnectionPoint } from "./connectionPoint.js";
/**
 * A ConnectionPoint whose runtimeData is never null - if not hooked up to a connection, it will use a default value.
 */
export class ConnectionPointWithDefault extends ConnectionPoint {
    /**
     * Create a new ConnectionPointWithDefault
     * @param name - The name the connection point has in the block
     * @param ownerBlock - The block the connection point belongs to
     * @param type - The type of the connection point
     * @param direction - The direction of the connection point
     * @param runtimeData - The runtimeData to use for this connection point if no connection is made
     */
    constructor(name, ownerBlock, type, direction, runtimeData) {
        super(name, ownerBlock, type, direction, runtimeData);
        this.runtimeData = runtimeData;
    }
}
//# sourceMappingURL=connectionPointWithDefault.js.map